import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toggleDarkMode } from '../../redux/authSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdjust } from '@fortawesome/free-solid-svg-icons';

const ToggleDarkmode = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(toggleDarkMode());
  };

  return (
    <Button className='ms-2' variant='light' onClick={handleClick}>
      <FontAwesomeIcon icon={faAdjust} />
    </Button>
  );
};

export default ToggleDarkmode;
